import { render, staticRenderFns } from "./VotingResults.vue?vue&type=template&id=51a02c9e&"
import script from "./VotingResults.vue?vue&type=script&lang=ts&"
export * from "./VotingResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports